<template>
  <div>
    <b-field
      label="Page URL*"
      class="personal-info__field block-title"
      :class="(countOfPages > 1)?'mt-35':'mt-0'"
      custom-class="personal-info__field-label"
    >
      <b-tooltip
        :label="tooltipText"
        class="block-tooltip is-gray"
        type="is-info"
        size="is-small"
        :delay="200"
        :position="getTooltipPositionByContentWidth(330, 'is-bottom')"
        animated
        multilined
      >
        <b-icon pack="fa" size="is-small" icon="question-circle" />
      </b-tooltip>
    </b-field>

    <div class="page-url-items">
      <template v-if="editable">
        <div class="page-url-url page-url-items-link">
          <a href="#">{{ categoryUrlActually }}</a>
        </div>
        <div class="page-url-name">
          <validation-provider
            v-slot="{ errors }"
            :rules="{
              required: true,
              regex: /[-a-zA-Z0-9]{2,100}/,
            }"
            :custom-messages="{
              regex: 'The URL is not valid'
            }"
          >
            <b-field
              class="personal-info__field page-url"
              custom-class="personal-info__field-label"
              :type="{ 'is-danger': errors.length }"
              :message="errors + [ '&nbsp;' ]"
            >
              <b-input
                :value.sync="pageName"
                type="text"
                maxlength="100"
                @blur="trimDashes"
                @input="updateValue"
                @keydown.native="onKeydown($event)"
              />
            </b-field>
          </validation-provider>
        </div>
      </template>
      <template v-else>
        <a :href="pageFullUrl" target="_blank">{{ pageFullUrl }}</a>
      </template>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import EditImage from '@/components/Modal/EditImage.vue';
import { getTooltipPositionByContentWidth } from '@/utils/getTooltipPosition';

export default {
  name: 'CoBrandedPagePageUrl',
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    pageName: {
      type: String,
      default: null,
    },
    categoryUrlActually: {
      type: String,
      default: null,
    },
    countOfPages: {
      type: Number,
      default: 0,
      required: true,
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cropModal: null,
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    pageFullUrl() {
      let fullUrl = '';

      if (this.categoryUrlActually && this.pageName) {
        fullUrl = `${this.categoryUrlActually}${this.pageName}`;
      }

      return fullUrl;
    },
  },
  methods: {
    getTooltipPositionByContentWidth,
    updateValue(newValue) {
      this.$emit('update:pageName', newValue);
    },
    showEditImage(file, modalIsActive) {
      const Component = Vue.extend(EditImage);
      this.cropModal = new Component({
        propsData: {
          show: modalIsActive,
          file,
        },
      });
      this.cropModal.$store = this.$store;
      this.cropModal.$mount();
      this.cropModal.$on('submit', (response) => {
        if (response) {
          this.updateBlobImageValue(response);
          const logo = URL.createObjectURL(response);
          this.updateLogoValue(logo);
          this.appendTo.removeChild(this.cropModal.$el);
        }
      });
      this.cropModal.$on('close', () => {
        this.appendTo.removeChild(this.cropModal.$el);
      });
      this.appendTo.appendChild(this.cropModal.$el);
      this.$refs.fileInput.value = '';
    },
    trimDashes() {
      const pageName = this.pageName.replace(/([-]+)/gu, '-').replace(/^[-]|[-]$/gu, '');
      this.updateValue(pageName);
    },
    onKeydown(e) {
      if (![8, 9, 13, 35, 36, 37, 38, 39, 40].includes(e.keyCode)) {
        if (/[^-a-zA-Z0-9]/gu.test(e.key)) {
          e.preventDefault();
        }
      }
    },
  },
};
</script>
